<template>
  <div
    @click="$emit('nav', 'about')"
    v-test="'summary-nav-about'"
  >
    <BaseCard>
      <General />
    </BaseCard>
  </div>

  <div
    @click="$emit('nav', 'resources')"
    v-test="'summary-nav-resources'"
  >
    <BaseCard>
      <Resources />
    </BaseCard>
  </div>

  <div
    @click="$emit('nav', 'advanced')"
    v-test="'summary-nav-advanced'"
  >
    <BaseCard>
      <Advanced />
    </BaseCard>
  </div>
</template>

<script
  setup
  lang="ts"
>
import Advanced from './service-details/Advanced.vue';
import General from './service-details/General.vue';
import Resources from './service-details/Resources.vue';

defineEmits(['nav']);
</script>
